export default __webpack_public_path__ + "static/media/main-mobile.e4492081.png";